import React, { PureComponent } from 'react';
import { withRouter, Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import { NonIdealState, Switch } from '@blueprintjs/core';

import cls from './EmptyList.module.css';

class EmptyList extends PureComponent {
  static propTypes = {
    isThisDesigning: PropTypes.bool,
    onDesigningModeChange: PropTypes.func,
  };

  render() {
    const { isThisDesigning } = this.props;

    return (
      <NonIdealState
        icon="circle"
        title="Your report is empty"
        description={
          <span>
            {'Your report can contain such elements as '}
            {'reactions, reference reactions and synthesis trees. In order to add new elements, turn '}
            <span className={cls.boldItalic}>editing mode</span>
            {' on for this report, navigate to your resources within '}
            <Link to="/dashboard/batch">searches</Link>
            {' and choose desired elements by clicking on '}
            <span className={cls.boldItalic}>Add to report</span>
            {' button.'}
          </span>
        }
        action={
          <Switch large checked={isThisDesigning} label="Editing mode" onChange={this.props.onDesigningModeChange} />
        }
      />
    );
  }
}

export default withRouter(EmptyList);
